export default defineNuxtPlugin(nuxtApp => {
  // TODO check if we can use the feature flag in posthog
  const config = useRuntimeConfig()

  const isAlpha = config.public.name === 'alpha'
  const isBeta = config.public.name === 'beta'
  const isApp = config.public.name === 'app'

  const features = {
    tableAdvancedSetting: isAlpha || isBeta,
    scrollable: isAlpha,
    learn: isAlpha || isBeta,
    qc: isBeta || isApp,
    trainingRuns: isAlpha,
    comments: isAlpha || isBeta,
    posthogTesting: isAlpha,
    showDocStatus: isAlpha || isBeta,
    showDocStatusInTable: isAlpha || isBeta,
    dan: isAlpha || isBeta,
    hermesTest: isAlpha || isBeta,
    notifications: isAlpha || isBeta,
    cancelSubscriptions: isAlpha || isBeta,
    dataSets: isAlpha || isBeta,
    siteAnalytics: isAlpha || isBeta,
    tableUX: isAlpha || isBeta || isApp,
    newSidebar: isAlpha || isBeta || isApp,
    pageTranslate: isAlpha,
    batchSummarize: isAlpha,
    structureTagAttributes: isAlpha || isBeta || isApp,
    uploadSortModal: isAlpha || isBeta || isApp,
    highlightSearchTerms: isAlpha || isBeta || isApp,
    sitesFilterMultiSelect: isAlpha || isBeta || isApp,
    sitesSearchMode: isAlpha || isBeta || isApp,
    labelsForModels: isAlpha || isBeta || isApp,
    structureTable: isAlpha,
    sitesWorldMap: isAlpha || isBeta || isApp,
    debug: isAlpha,
    projects: isAlpha,
    advancedRegionSort: isAlpha || isBeta || isApp,
    findDocumentsBySearchRequest: isAlpha || isBeta || isApp,
    collectionActivityChart: isAlpha || isBeta || isApp,
    collectionColor: isAlpha || isBeta || isApp,
    e2eModelsEditor: isAlpha,
    loadingAudit: isAlpha || isBeta || isApp,
    smartExtract: isAlpha,
    mobileTopNavbar: isAlpha || isBeta || isApp,
    actionBarInRecents: isAlpha || isBeta || isApp,
    ftpUpload: isAlpha || isBeta || isApp,
    siteMetaColumns: isAlpha || isBeta || isApp,
    sitesTagSearch: isAlpha,
    readingOrderStyling: isAlpha || isBeta || isApp,
    fontSizeSlider: isAlpha || isBeta || isApp,
    singleImageButton: isAlpha || isBeta || isApp,
    regionCrosshairs: isAlpha || isBeta || isApp,
    whiteEditorNavbar: isAlpha || isBeta || isApp, //Reset this to alpha if not ready for release: https://app.clickup.com/t/9015462083/DEV-4115
    tableTrainingLayers: isAlpha,
    userStorageDisplay: isAlpha || isBeta || isApp,
  }
  return {
    provide: {
      features,
    },
  }
})
